import styled from 'styled-components';

export const CheckboxOptionWrap = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
`;

export const CheckboxOptionText = styled.div`
  display: flex;
  font-size: ${({ theme }) => theme.elementFontSizes.checkbox};

  .icon-with-tooltip {
    margin-left: 5px;
  }
`;
